// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey            : "AIzaSyB-Wm5DrVL4180UpWNdPi7FraWA9R1tpwE",
    authDomain        : "spa-safefleet.firebaseapp.com",
    projectId         : "spa-safefleet",
    storageBucket     : "spa-safefleet.firebasestorage.app",
    messagingSenderId : "854098882072",
    appId             : "1:854098882072:web:a5d0ce6ff68bd9fddd5d6d",
    measurementId     : "G-YYCR0HTJG0",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)

export { analytics }